import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="form-help"
export default class extends Controller {
  static targets = [ 'window', 'content', 'error', 'link' ]
  static values = {
    url: { type: String, required: true } ,
    status: { type: Boolean, default: false }
  }

  connect () {
    this.token = document.querySelector(
      'meta[name="csrf-token"]'
    ).content

    if (this.statusValue) {
      this.linkTarget.classList.add('hidden')
    }

    this.cache = []
  }

  toggle (evt) {
    // console.log('form-help link clicked')
    evt.preventDefault()

    this.linkTarget.classList.toggle('hidden')
    this.statusValue = !this.statusValue

    if (! this.statusValue) this.windowTarget.classList.add('hidden')

    alert(`Die Hilfeanzeige ist ${this.statusValue ? 'aktiviert' : 'deaktiviert'}.`)
  }

  show_error (content) {
    if (content?.length <= 5) this.errorTarget.parentElement.closest('div').classList.add('hidden')
    else {
      this.errorTarget.parentElement.closest('div').classList.remove('hidden')
      this.errorTarget.innerHTML = content
    }
  }

  async show (evt) {
    // console.log('form-help#show', evt.params)
    let value = ''
    let found = null
    let error = evt.params.error

    this.show_error(error)

    if (!this.statusValue) return

    if (found = this.cache.find(c => c.table == evt.params.table && c.field == evt.params.field)) {
      value = found.content
    } else {
      value = await this.get(evt.params.table, evt.params.field)
      this.cache.push({ table: evt.params.table, field: evt.params.field, content: value })
    }

    // console.log(this.contentTarget.parentElement.closest('div'))
    this.contentTarget.innerHTML = value

    if (value.length <= 5) this.contentTarget.parentElement.closest('div').classList.add('hidden')
    else this.contentTarget.parentElement.closest('div').classList.remove('hidden')

    //
    // every field has an field help.
    // because of usability we are looking here
    // to see if there is a warning nearby this field
    // if so, we click the field. this is a workaround to save a click for the user
    //
    const found_field = Array.from(evt.target.parentElement.children)
                             .find((element) => { return element.classList.contains('warning')})
    if (found_field) { found_field.click() }
  }

  close (evt) {
    this.element.classList.add('hidden')
    this.element.remove()
  }

  async get (table, field) {
    // console.log(`form-help#fetch: ${ table } - ${ field }`)

    const form = new FormData()
    form.append('table', table)
    form.append('field', field)
    form.append('help_sytem_status', ( this.statusValue ? 1 : 0 ) )

    const value = await fetch(this.urlValue, {
      method: 'post',
      headers: {
        'X-CSRF-Token': this.token,
        // Accept: 'text/vnd.turbo-stream.html',
        // 'Content-Type': 'application/json'
      },
      credentials: 'same-origin',
      body: form
    }).then(response => response.text())
      .then(html => {
        // Turbo.renderStreamMessage(html)
        //  console.log('form-help#fetch', html)
        return html
      })
    return value
  }
}


